import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { person } from "../lib/data";

const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [80, -80]);

  return (
    <section id="about" ref={ref} className="py-24 md:py-36 relative" data-testid="about">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="section-label mb-6">◆ Personal Profile</div>
        <h2 className="h-display text-5xl md:text-7xl lg:text-8xl mb-16 md:mb-24">
          Visual <span className="font-serif-i text-[color:var(--nn-muted)]">Thinker.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start">
          <motion.figure
            style={{ y: y1 }}
            className="md:col-span-5 relative rounded-2xl overflow-hidden border border-[color:var(--nn-border)] aspect-[3/4] group"
            data-testid="about-portrait"
          >
            <img
              src={person.portrait}
              alt="Nirav Nayak"
              className="w-full h-full object-cover object-top transition-transform duration-[1400ms] group-hover:scale-[1.03]"
              loading="lazy"
            />
          </motion.figure>

          <div className="md:col-span-7 flex flex-col gap-10">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <div className="font-mono text-[11px] uppercase tracking-widest text-[color:var(--nn-muted)] mb-2">
                  Experience
                </div>
                <div className="h-display text-6xl md:text-7xl">
                  {person.yearsExperience}
                  <span className="text-[color:var(--nn-accent-text)]">+</span>
                </div>
                <div className="mt-2 text-sm text-[color:var(--nn-muted)]">Years shipping product</div>
              </div>
              <div>
                <div className="font-mono text-[11px] uppercase tracking-widest text-[color:var(--nn-muted)] mb-2">
                  Retention
                </div>
                <div className="h-display text-6xl md:text-7xl">
                  {person.clientRetention}<span className="text-[color:var(--nn-accent-text)]">%</span>
                </div>
                <div className="mt-2 text-sm text-[color:var(--nn-muted)]">Client retention rate</div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <p className="font-serif-i text-2xl md:text-3xl leading-tight text-[color:var(--nn-text)]">
                "Where AI, accessibility, and usability shape thoughtful UI/UX systems."
              </p>
              <p className="text-[color:var(--nn-text)]/80 leading-relaxed text-base">
                Designing end-to-end experiences enhanced by structure, flow, and subtle
                micro-animations. I care about the moment a first-time user realises the product
                just works — and the moment a power user realises it also gets out of the way.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4 pt-6 border-t border-[color:var(--nn-border)]">
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--nn-muted)] mb-2">Based in</div>
                <div className="font-display text-xl md:text-2xl">{person.location}</div>
              </div>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--nn-muted)] mb-2">Currently</div>
                <div className="font-display text-xl md:text-2xl">YuJa Inc</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
